import { render, staticRenderFns } from "./ZeroEmissiezones.vue?vue&type=template&id=2c70c1b3"
import script from "./ZeroEmissiezones.vue?vue&type=script&lang=js"
export * from "./ZeroEmissiezones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports